import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SafeHtmlParser } from "./SafeHtmlParser";
import ContactForm from "./contactForm";

const Form1 = ({ heading }) => {
	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row className="justify-content-center">
					{/* Left Text Section */}
					<Col lg={8} xl={6} className=" mb-md-0 text-center ">
						<div className="mb-5 mb-lg-7" style={{ color: "#00304B" }}>
							<SafeHtmlParser htmlContent={heading} />
						</div>
						<Row className="justify-content-center">
							<Col md={8} lg={10}>
								<ContactForm />
							</Col>
						</Row>
					</Col>

					{/* Right Form Section */}
				</Row>
			</Container>
		</section>
	);
};

export default Form1;
